import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-img-c',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './img-c.component.html',
  styleUrl: './img-c.component.scss'
})
export class ImgCComponent {
  @Input()
  url: string = '/assets/branding/softnet-negombo-best-computer-store.png';

  @Input()
  alt: string = 'softnet';

  @Input()
  i: number = 0;


  @Input()
  size: number = 800;

}
